export const endpoints = {
  GET_PRICING_DETAILS_LIST: "/subscriptions/subscription-plans/",
  CREATE_CHECKOUT_SESSION: "/subscriptions/checkout-sessions/",
  GET_ME_DETAILS: "/users/me/",
  CONTACTS: "/contacts/",
};
